import { useEffect } from 'react';
import { useCourseEnrollees } from '../hooks/use-course-enrollees';
import { useSelectedStudents } from '../hooks/use-selected-students';
import { courseEnrolleeCount } from '../utilities/course-enrollee-count';
import { useCandidatesCache } from '../hooks/use-candidates-cache';
import { sample } from 'lodash';


//  Filters
const courseHasVacancy = (courseEnrollees) => (course) => courseEnrolleeCount(course, courseEnrollees) < course?.maxCapacity;
const courseIsDuringHour = (hourId) => (course) => course.hourId === hourId;

export const CandidateDistributor = () => {
    const {
        selectedStudents
    } = useSelectedStudents();
    const {
        courseEnrollees,
        setCourseEnrollees
    } = useCourseEnrollees();

    const { courses } = useCandidatesCache();

    useEffect(() => {
        const selectedStudentIds = selectedStudents.map(s => s.id);
        const enrolledStudentIds = courseEnrollees.map(ce => ce.userId);

        //  Get a list of students that need to be removed from the enrollees
        const studentIdsToRemove = enrolledStudentIds.filter(id => !selectedStudentIds.includes(id));
        studentIdsToRemove.forEach(id => {
            setCourseEnrollees(courseEnrollees => courseEnrollees.filter(ce => ce.userId !== id));
        });

        //  Get a list of students that need enrollments (selected but not enrolled and has preferred hour)
        const newStudents = selectedStudents.filter(s => !enrolledStudentIds.includes(s.id) && s.hourId);
        newStudents.forEach(s => {
            setCourseEnrollees(courseEnrollees => {
                //  Find a course that has room for the student
                const vacantCourses = courses.filter(courseHasVacancy(courseEnrollees));

                //  Find a course that fits the student's hour
                const availableCourses = vacantCourses.filter(courseIsDuringHour(s.hourId));
                //  Get preferred hour or any
                const course = sample(availableCourses);

                if (!course) {
                    console.error('Auto Enrollment Distribution: No available courses for student based on preferred hour:', s);
                    return [
                        ...courseEnrollees
                    ];
                }

                return [
                    ...courseEnrollees,
                    {
                        userId: s.id,
                        courseId: course.id
                    }
                ]
            });
        });

    }, [
        selectedStudents,
        courseEnrollees,
        courses
    ]);

    return null;
}